import { Spacing } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

export const pdfStyles = StyleSheet.create({
  graphImage: {
    width: '100%',
    marginBottom: Spacing.S8,
  },
})
